
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppDateTimePicker } from '@/components';
import { useArenaItemAdd } from '@/modules/arena/item/model/add';
import { ArenaTicketTypeList } from '@/modules/arena/ticket/model/mixins';
import { timeUnits } from '@/common/utils/helpers';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';

export default defineComponent({
    name: ROUTE_NAME_ARENA.ITEM.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppDateTimePicker },
    setup() {
        const { model, v$, gameMatchOptions, actions } = useArenaItemAdd();

        return { model, v$, gameMatchOptions, actions, ArenaTicketTypeList, timeUnits };
    }
});
